ACC.healthcare = {
  checkboxErrorClass: '.ph-anonymous_healthcare__professional--checkboxerror',
  displayNone: 'ph-d-none',
  dataStep: 'data-step',
  dataIntro: 'data-intro',

  showAnonymousHealthCarePopup: function() {
    $.colorbox({
      html: $('.ph-anonymous_healthcare__professional--popup').html(),
      maxWidth: '720px',
      width: '100%',
      height: 'auto',
      closeButton: false,
      overlayClose: false,
      escKey: false,
      onComplete: function() {
        ACC.healthcare.setPopupTopPosition();

        var isHealthCareChecked = '';

        $(document).on('click', '#cboxLoadedContent .ph-anonymous_healthcare__professional--main input[id=ph-anonymousHealthCareProfessional]', function() {
          if ($(this).is(':checked')) {
            isHealthCareChecked = true;
            $(ACC.healthcare.checkboxErrorClass).addClass('hidden');
          } else {
            isHealthCareChecked = false;
            $(ACC.healthcare.checkboxErrorClass).removeClass('hidden');
          }
        });

        $(document).on('click', '#cboxLoadedContent .ph-anonymous_healthcare__professional--main .ph-anonymous_healthcare__professional--submit', function() {
          if (isHealthCareChecked) {
            document.cookie = 'isHealthCareProfessional=true;path=/';
            $(ACC.healthcare.checkboxErrorClass).addClass('hidden');
            $.colorbox.close();
            $('body').removeClass('ph-visibility-hidden');
            ACC.healthcare.showDivsOnpage();
          } else {
            $(ACC.healthcare.checkboxErrorClass).removeClass('hidden');
          }
        });
        $(document).on('click', '#cboxLoadedContent .ph-anonymous_healthcare__professional--cancel', function() {
          $.colorbox.close();
        });
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },

  getCookieValue: function(cookieName) {
    var cookieNameEqual = cookieName + '=',
        decodedCookie = decodeURIComponent(document.cookie),
        splittedCookie = decodedCookie.split(';');

    for (var index = 0; index < splittedCookie.length; index = index + 1) {
      var splittedCookieEachChar = splittedCookie[index];

      while (splittedCookieEachChar.charAt(0) === ' ') {
        splittedCookieEachChar = splittedCookieEachChar.substring(1);
      }

      if (splittedCookieEachChar.indexOf(cookieNameEqual) === 0) {
        return splittedCookieEachChar.substring(cookieNameEqual.length, splittedCookieEachChar.length);
      }
    }

    return '';
  },

  setPopupTopPosition: function() {
    if ($(window).width() === 768) {
      var topPos = $('.ph-anonymous_healthcare__professional--popup').offset().top + 100;

      $('#colorbox').css('top', topPos);
    }
  },

  hideDivsOnpage: function() {
    $('.ph-page-search .ph-breadcrumbs_wrapper').addClass(ACC.healthcare.displayNone);
    $('.ph-page-productDetails .ph-breadcrumbs_wrapper').addClass(ACC.healthcare.displayNone);
    $('.ph-page-productList .ph-breadcrumbs_wrapper').addClass(ACC.healthcare.displayNone);
    $(ACC.breadcrumbs.breadcrumbId).find('.ph-category-breadcrumb').removeClass('ph-visible');
  },

  showDivsOnpage: function() {
    $('.ph-page-search .ph-breadcrumbs_wrapper').removeClass(ACC.healthcare.displayNone);
    $('.ph-page-productDetails .ph-breadcrumbs_wrapper').removeClass(ACC.healthcare.displayNone);
    $('.ph-page-productList .ph-breadcrumbs_wrapper').removeClass(ACC.healthcare.displayNone);
    $(ACC.breadcrumbs.breadcrumbId).find('.ph-category-breadcrumb').addClass('ph-visible');
  },
  introAnonymousHomePage: function() {
    if ($('.ph-introjsvalue').text() === 'true') {
      var $introsearch = $('.ph-searchparent__input'),
          introSearch = '<div class="ph-introjs__header ph-notLoggedinSearch">' + $introsearch.attr('data-introsearchheader') +
                         '</div><div class="ph-introjs__text ph-notLoggedinSearch">' + $introsearch.attr('data-introsearchtext') + '</div>';

      if (ACC.healthcare.getCookieValue('introAnonymousHomePage') !== 'true' && $('.srcTooltipIntroJs').text().split('-')[0] !== 'hhs') {
        $introsearch.attr(ACC.healthcare.dataStep, $introsearch.attr('data-stepNumber'));
        $introsearch.attr(ACC.healthcare.dataIntro, introSearch);

        document.cookie = 'introAnonymousHomePage=true;path=/';
      }
    }
  },
  introAnonymousOrderSearchPage: function() {
    if ($('.ph-introjsvalue').text() === 'true') {
      var $introsearch = $('.ph-searchAnonymousOrders'),
          introSearch = '<div class="ph-introjs__header ph-introAnonymousUser">' + $introsearch.attr('data-iconintroheader') +
                         '</div><div class="ph-introjs__text ph-introAnonymousUser">' + $introsearch.attr('data-iconintrotext') + '</div>',
          $introIsSparepart = $('.ph-sparePartRadio'),
          introIcon = '<div class="ph-introjs__header">' + $introIsSparepart.attr('data-iconintroheader') +
                       '</div><div class="ph-introjs__text">' + $introIsSparepart.attr('data-iconintrotext') + '</div>';

      $introsearch.attr(ACC.healthcare.dataStep, $('.ph-stepNumber-searchAnonymousOrders').text());
      $introsearch.attr(ACC.healthcare.dataIntro, introSearch);

      $introIsSparepart.attr(ACC.healthcare.dataStep, $introIsSparepart.attr('data-stepNumber'));
      $introIsSparepart.attr(ACC.healthcare.dataIntro, introIcon);
      document.cookie = 'introAnonymousOrderSearchPage=true;path=/';
    }
  }
};

$(document).ready(function() {
  if (ACC.healthcare.getCookieValue('isHealthCareProfessional') === 'false' &&
    $('body').hasClass('ph-anonymousPopup')) {
    ACC.healthcare.hideDivsOnpage();
    ACC.healthcare.showAnonymousHealthCarePopup();
  } else {
    $('body').removeClass('ph-visibility-hidden');
  }
});
